let { getDebugControlBoolean } = require('./debugControlPanel.js');
let { isDebuggerProduction } = require('../config/index.js');

let isProxy = true; // 是否使用webpack的代理
let proxyMap = {
  production: {
    api: 'https://api.xingbaidesign.com/',
    oss1: 'https://cdn.elfinbook.com/'
  },
  dev: {
    api: 'http://api.book.com/',
    oss1: 'http://elfinbook-test.oss-cn-shanghai.aliyuncs.com/',
    oss1_reg: /http(s)?:\/\/elfinbook-test.oss-cn-shanghai\.aliyuncs\.com/g,
    oss2: 'http://elfinbook-test-public.oss-cn-shanghai.aliyuncs.com/',
    oss2_reg: /http(s)?:\/\/elfinbook-test-public.oss-cn-shanghai.aliyuncs\.com/g
  }
};
const proxySetting = proxyMap[isDebuggerProduction ? 'production' : 'dev'];
// console.log('proxySetting', proxySetting);
let buildForTest = false;
if (process.env.build_mode == 'test') {
  isProxy = false;
  buildForTest = true;
}

let isDev = process.env.NODE_ENV == 'development';

function isTestMode() {
  return isDev;
}

/**
 * 在浏览器环境读取调试面板布尔配置；Node 加载 vue.config.js 时直接使用默认值。
 * @param {string} key - 调试面板配置键名
 * @param {boolean} fallback - 无法读取调试面板时使用的默认值
 * @returns {boolean} 解析后的开关值
 */
function getDebugControlBooleanSafely(key, fallback) {
  if (typeof window === 'undefined') {
    return fallback;
  }
  try {
    let { getDebugControlBoolean } = require('./debugControlPanel.js');
    return getDebugControlBoolean(key, fallback);
  } catch (error) {
    return fallback;
  }
}

/**
 * 判断当前是否使用管理员调试模式。
 * @returns {boolean} 管理员调试模式开启时返回 true
 */
function isAdminMode() {
  let defaultIsAdmin =
    (typeof localStorage !== 'undefined' &&
      localStorage.getItem('isAdmin') == '1') ||
    (typeof location !== 'undefined' &&
      location.host == 'app.book.com' &&
      isDev);
  return getDebugControlBooleanSafely('isAdmin', defaultIsAdmin);
}

module.exports = {
  proxySetting,
  isDebuggerProduction,
  isProxy,
  buildForTest,
  lastUpdateDateTime: '2025-12-06 18:00:00',
  isTestMode,
  isAdminMode
};
